module.exports = __webpack_public_path__ + "img/Smokescreen_Reel.31824f2f.jpg";